import { Link } from 'react-router-dom'

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-black text-white border-b border-charcoal-800">
      {/* Background Image - Logistics/Shipping */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 600'%3E%3Cg fill='white' opacity='0.3'%3E%3Crect x='50' y='200' width='80' height='60' rx='5'/%3E%3Crect x='150' y='180' width='80' height='80' rx='5'/%3E%3Crect x='250' y='220' width='80' height='40' rx='5'/%3E%3Cpath d='M400 150 L500 150 L520 200 L480 250 L380 250 L360 200 Z'/%3E%3Ccircle cx='420' cy='270' r='15'/%3E%3Ccircle cx='480' cy='270' r='15'/%3E%3Cpath d='M600 180 L750 180 L750 240 L600 240 Z' stroke='white' stroke-width='2' fill='none'/%3E%3Cpath d='M900 160 L950 160 L970 200 L950 240 L900 240 L880 200 Z'/%3E%3Cline x1='100' y1='400' x2='1100' y2='400' stroke='white' stroke-width='2' stroke-dasharray='10,5'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }} />
      </div>

      {/* Grid Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Subtle gradient overlays */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-5" />
      <div className="absolute bottom-20 right-10 w-80 h-80 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-5" />

      <div className="relative section-container">
        <div className="max-w-4xl mx-auto text-center py-16 md:py-24">
          {/* Main Heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-bold mb-6 animate-slide-up leading-tight">
            Smart Logistics Solutions{' '}
            <span className="text-gradient">
              That Drive Your Business Forward
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-3xl mx-auto animate-slide-up" style={{ animationDelay: '0.1s' }}>
            Seamless freight forwarding, customs clearance, and end-to-end supply chain management — connecting your business to global markets with accuracy, speed, and trust.
          </p>

          {/* Trust Indicators */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-3 gap-8 animate-fade-in" style={{ animationDelay: '0.3s' }}>
            {[
              { value: '700+', label: 'Worldwide Logistics Partners' },
              { value: '98%', label: 'On-Time Delivery Success' },
              { value: '24/7', label: 'Dedicated Support Team' }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-gray-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Wave Divider */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg className="w-full h-16 fill-black" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" />
        </svg>
      </div>
    </section>
  )
}

export default Hero
